import { gql } from '../__generated__/index.js';

//language=graphql
export const deleteGift = gql(`
    mutation deleteGift($giftId: ID!) {
        deleteGift(giftId: $giftId)
    }
`);
